import React from 'react';
import { Navigate } from 'react-router';
import DriverLogPage from './components/DriverLogPage';
import { HIDE_SYSTEM_ROUTE } from '../../configs';

const routes = [
  // {
  //   path: '/',
  //   component: () => <Navigate to="/driver-log" />,
  //   weight: 2,
  //   hideOnMenu: HIDE_SYSTEM_ROUTE,
  //   permission: [],
  //   children: [],
  //   loginRequired: true,
  // },
  {
    path: '/driver-log',
    name: 'menu.driver',
    icon: 'driver-log',
    customIcon: true,
    loginRequired: true,
    component: DriverLogPage,
    weight: 2,
    permission: [],
    children: [],
  },
];

export default routes;
